export default __webpack_public_path__ + "static/logo_1-bf3ef997ca9593f2042628d2d3c27062.jpg";